module.exports = __webpack_public_path__ + "img/wijziging-persoonlijke-situatie.46b4cae2.png";